import Label from './Label'
export type {LabelProps, LabelColorOptions} from './Label'
export {variants} from './Label'
export default Label
